import clsx from "clsx";
import { createRef, FC } from "react";
import { IObjectMaterial } from "../../interface";
import { BgImage } from "../bg-image";
import { ButtonProps } from "../button";
import { Icon } from "../icon";
import "./style.scss";

type ToolbarButtonProps = {
    selected?: string;
    disable?: boolean;
    isMobile?: boolean;
    image?: string;
    material?: IObjectMaterial;
} & ButtonProps;

export const ToolbarButton: FC<ToolbarButtonProps> = ({
    disable = false,
    text,
    active = false,
    className,
    isMobile = false,
    ref,
    variant,
    image,
    selected,
    material,
    icon,
    iconFill = false,
    onClick,
}) => {
    const buttonRef = ref || createRef();

    return (
        <button
            ref={buttonRef}
            onClick={(e) => {
                if (onClick) {
                    onClick(e);
                }
            }}
            className={clsx(
                "button btn-toolbar",
                disable && "disabled",
                active && "active",
                isMobile && "mobile",
                className,
            )}
        >
            {icon && <Icon name={icon} fill={iconFill} />}
            {image && <BgImage src={image} />}
            {text && (
                <div className="text">{!selected && selected !== "None" ? text : selected}</div>
            )}
        </button>
    );
};
